import script from "./QuickReplies.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickReplies.vue?vue&type=script&lang=ts&setup=true"

import "./QuickReplies.vue?vue&type=style&index=0&id=224848da&lang=css"

const __exports__ = script;

export default __exports__